<template>
  <b id="modalImei">
    <div class="content-imei">
    <p class="title" >Cadastrar IMEI</p>
    <b-row>
      <b-col sm=2 class="cel-imei" >
        <img src="../../assets/svg/cel-imei.svg" alt="" class="cel-imei">
      </b-col>
      <b-col sm=10 >
        <p class="instrucao-imei">
          1. Abra o discador de seu telefone. <br><br>
          2. Digite o seguinte código no teclado:<span>*#06#</span> <br><br>
          3. Depois que você digitar o código, o número do IMEI será apresentado automaticamente na tela.
        </p>
      </b-col>
      <b-col>
        <v-text-field
          label="IMEI"
          ref="IMEI"
          v-model="IMEI"
          v-mask="['######-##-######-#']"
          placeholder="000000-00-000000-0"
          :rules="[
            () => !!IMEI || 'Por favor, preencha esse campo',
            () => IMEI.length == 18 || 'Preencha o campo corretamente',
            () => ImeiValido || mensagemIMEI
          ]"
          required
        ></v-text-field>
        <Button
          class="quero-proteger"
          @click="postIMEI()"
          :disabled="this.IMEI.length != 18 && !this.checkButton"
          label="Cadastrar IMEI"
          theme="purple"
        />
      </b-col>
    </b-row>
  </div>
  </b>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import './ImeiCadastro.css'

  import Button from '@/components/ui/Button'

  export default {
    name: 'ImeiCadastro',
    props: {
      policy: String,
      onSuccess: {
        type: Function,
        default: () => {}
      }
    },
    components: {
      Button
    },
    data () {
      return {
        IMEI: '',
        userUuid: '',
        Uuid: '',
        checkButton: false,
        ImeiValido: true,
        mensagemIMEI: ''
      }
    },
    computed: {
      ...mapState(['device'])
    },
    mounted () {
      if (this.$route.query.id) {
        this.$store.state.device.payment = {
          planUuid: this.$route.query.id
        }
      }
    },
    methods: {
      postIMEI () {
        window.dataLayer.push({
          event: 'dispositivos-ciclic',
          categoria: 'cadastro-dispositivo',
          acao: 'IMEI',
          rotulo: 'enviar'
        })

        axios
        .patch(`${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/policy/imei`, {
          'uuid': this.device.payment.planUuid,
          'serialNumber': this.IMEI
        }, JSON.parse(sessionStorage.config))
        .then((response) => {
          this.checkButton = false
          this.ImeiValido = true
          this.$emit('confirmDeviceIdentification', true)
          this.$bvModal.hide('modalDeviceIdentification')
          this.$bvModal.show('MODAL_SUCESSO')
          if (this.onSuccess) {
            this.onSuccess()
          }
        }).catch((error) => {
          console.log(error.response.data)
          const status = error.status || error.response.data.status || error.response.data[0].status
          if (status === 400) {
            this.mensagemIMEI = 'IMEI inválido'
          } else if (error.response.data.status === 404) {
            this.mensagemIMEI = 'Ocorreu um erro. Por favor tente novamente'
          } else {
            this.mensagemIMEI = 'Ocorreu um erro. Por favor tente novamente'
            this.$sentry.logWithContext({ ctx: { step: '[IMEI]' }, error })
          }
          this.checkButton = true
          this.ImeiValido = false
          this.$refs.IMEI.validate(true)
          // Limpa para futuras validações do IMEI
          this.ImeiValido = true
        })
      }
    }
  }
</script>
